import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pubg',
  templateUrl: './pubg.component.html',
  styleUrls: ['./pubg.component.css']
})
export class PubgComponent implements OnInit {

  gameName = "pubg";

  constructor() { }

  ngOnInit() {
  }

}
